import type maplibregl from 'maplibre-gl'

/**
 * Runs map work that might arrive after the map has been destroyed.
 *
 * HereMapNew calls useMapLibreInstance before the territory hooks, and React runs effect
 * cleanups in declaration order -- so on unmount `mapInstance.remove()` happens FIRST and every
 * cleanup after it is holding a dead map. Touching one throws
 * `Cannot read properties of undefined (reading 'getSource')`, because Map.getSource and
 * Map.setFeatureState both reach through `this.style`, which remove() has already torn down.
 *
 * The map view is a dialog, and this flow now closes it programmatically -- after naming a
 * territory drawn for an assignment rule (WWM-17508) -- so an unmount while a territory is
 * hovered or selected went from unlikely to routine.
 *
 * Checked AND caught: the flag is maplibre's own record of having been removed, and the catch
 * covers the window where a style is mid-teardown but the map does not yet call itself removed.
 * Nothing here is worth failing a teardown over -- the state being cleaned up died with the map.
 */
export function whenMapAlive(
  map: maplibregl.Map | null,
  work: (map: maplibregl.Map) => void,
): void {
  if (!map) return
  if ((map as unknown as { _removed?: boolean })._removed) return

  try {
    work(map)
  } catch {
    // The map went away underneath us. There is nothing left to clean up on it.
  }
}
